import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { saveMessageForZenith } from "@services/message";
import { invalidateNotifications } from "@hooks/query/useAllNotifications";

export function useCreateMessage(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation<any, any, any>({
    ...options,
    mutationKey: ["create_message"],
    mutationFn: saveMessageForZenith,
    onSuccess: () => {
      invalidateNotifications(queryClient);

      if (isFunction(options.onSuccess)) {
        options.onSuccess();
      }
    },
  });
}
